import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const AmenitiesWrapper = styled.div`
  padding: 29px 0;

  .amenities_title {
    margin-bottom: 30px;
  }

  button {
    font-size: 15px;
    font-weight: 700;
    border: 0;
    padding: 0;
    height: auto;
    line-height: 1;
    box-shadow: none;
    text-shadow: none;
    color: ${themeGet('primary.0', '#194AB9')};

    &::after {
      content: none;
    }
  }

  a {
    &:hover {
      color: #31b8bd;
    }
  }
`;

export const AmenitiesArea = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  margin-bottom: -15px;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media only screen and (max-width: 991px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media only screen and (max-width: 767px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media only screen and (max-width: 580px) {
    grid-template-columns: repeat(2, 1fr);
  }
  ${({ collapsed, height }) =>
    collapsed
      ? css`
          height: ${height}px;
          overflow: hidden;
        `
      : css`
          height: auto;
        `}

  > div {
    width: 100%;

    @media only screen and (max-width: 767px) {
      margin-bottom: 20px;
    }
  }
`;

export default AmenitiesWrapper;
